// extracted by mini-css-extract-plugin
module.exports = {"navigation":"PagedListNavigation_navigation__245iZ","separator":"PagedListNavigation_separator__16_yn"};